import { FlexDiv } from "src/common/styles/div";
import styled from "styled-components";

export const Container = styled(FlexDiv)`
`
export const Description = styled.label`
`
export const Date = styled.label`
    color: #8c8c8c;
    font-size: 13px;
`